import { jsx as _jsx } from "react/jsx-runtime";
import { DigitalCheckout, StoreProvider, getDefaultFieldValues, } from '@systemeio/digital-store-shared';
import { CheckoutProviders } from '../hoc/checkout-providers';
import { VisitorInfoProvider } from '../hoc/visitor-info-provider';
export function DigitalProductCheckoutApp({ pageWithProviders }) {
    const { locale, design, ...page } = pageWithProviders;
    const { checkoutPage: { offerId, fields, digitalProductId }, pricePlans, currency, paymentMethods, } = page;
    const selectedPricePlan = pricePlans?.[0];
    const selectedPaymentMethod = paymentMethods?.[0];
    return (_jsx(StoreProvider, { initProps: {
            offer: {
                pricePlan: selectedPricePlan,
                paymentMethod: selectedPaymentMethod,
                currency,
                offerId: offerId ?? undefined,
                productId: digitalProductId,
                finalAmount: selectedPricePlan?.amount,
                availablePaymentMethods: paymentMethods,
                contactFields: getDefaultFieldValues(fields),
            },
            base: { locale },
        }, children: ({ store }) => {
            const { offer } = store();
            return (_jsx(VisitorInfoProvider, { children: _jsx(CheckoutProviders, { calculatePriceProps: {
                        offer: offer.offerId ?? null,
                        paymentMethod: offer.paymentMethod,
                        pricePlan: offer.pricePlan ?? null,
                        quantity: 1,
                        productId: null,
                    }, design: design, offerId: page.checkoutPage.offerId, locale: locale, children: ({ calculatePrice, isLoadingCalculatePrice }) => (_jsx(DigitalCheckout, { ...page, calculatePrice: calculatePrice, isLoadingCalculatePrice: isLoadingCalculatePrice })) }) }));
        } }));
}
